<script>
   /**************************************************************/
   /* ResultsTable                                               */
   /* -------------------------                                  */
   /* shows table with SIMCA results for training and PV-sets    */
   /**************************************************************/

   // main properties of the whole app
   let { calres, pvres, ncomp } = $props();
   let nrows = $derived(calres ? calres.v[0].rols.length : 0);
</script>


{#if calres && pvres}
<table>
   <thead>
   <tr>
      <th></th>
      <th>Cal</th>
      <th>PV</th>
   </tr>
   </thead>
   <tbody>
   <tr>
      <td class="label">Objects</td>
      <td>{nrows}</td>
      <td>{nrows}</td>
   </tr>
   <tr>
      <td class="label">Extremes</td>
      <td>{calres.v[ncomp - 1].rolsNum.extreme}</td>
      <td>{pvres.v[ncomp - 1].rolsNum.extreme}</td>
   </tr>
   <tr>
      <td class="label">Outliers</td>
      <td>{calres.v[ncomp - 1].rolsNum.outlier}</td>
      <td>{pvres.v[ncomp - 1].rolsNum.outlier}</td>
   </tr>
   <tr>
      <td class="label">Sensitivity</td>
      <td>{calres.stat.sensitivity[ncomp - 1].toFixed(3)}</td>
      <td>{pvres.stat.sensitivity[ncomp - 1].toFixed(3)}</td>
   </tr>
   </tbody>
</table>
{/if}

<style>
   table {
      width: 100%;
      border-collapse: collapse;
   }

   tr {
      width: 100%;
   }

   th {
      border-bottom: 1px solid #a0a0a0;
   }

   th, td {
      text-align: right;
      padding: 0.2em 0.5em 0.2em 0.1em;
      color: #404040;
      margin: 0;
   }

   .label {
      text-align: left;
      padding: 0.1em 0.5em;
   }
</style>